import React from "react";
import {
  makeStyles,
  Typography,
  Button,
} from "@material-ui/core";
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import queryString from "query-string";
import useAuth from "Hooks/useAuth";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  iframe: {
    width: "100%",
    maxWidth: "100%",
    height: "100%", 
    border: "none",
  },
  floating: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "5px",
  },
  adminMode: {
    margin: "0 10px",
    lineHeight: "36px",
    color: "red",
  },
  anchor: {
    textDecoration: "underline",
  },
}));

function Users(props) {
  const auth = useAuth();
  const classes = useStyles();

  // Update 2023.03.31 投稿分類
  const { account_id, adminname, contract_type, media, analysis, admintoken } = queryString.parse(props.location.search);
  const customerScreen = document.getElementById("customerScreen");

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - 顧客画面";
    
    auth.login({
      user: {
        account_id: account_id,
        name: adminname,
        contract_type: contract_type,
        options: {
          media: media,
          // Add 2023.03.31 投稿分類
          analysis: analysis,
        },
        admin: true,
        master: true,
      },
      token: admintoken,
    });

    localStorage.setItem("customerScreenMode", true);
  }, []);

  const iframeOnload = () => {
    customerScreen.style.height = (document.documentElement.clientHeight * 0.92) + "px";
    customerScreen.style.border = "5px solid red";
  }  

  return (
    <>
      <iframe
        id="customerScreen"
        src="/dashboard"
        onLoad={iframeOnload}
        className={classes.iframe}
      >
      </iframe>
      <div className={classes.floating}>
        <Typography
          className={classes.adminMode}
        >
          - 管理者モード -
        </Typography>
        <Button 
          className={classes.anchor} 
          color="inherit" 
          component={Link} 
          to={`/admin/customerScreen`} 
          onClick={() => localStorage.removeItem("customerScreenMode")}
        >
          管理画面に戻る
        </Button>
      </div>
    </>
  );
}

export default withRouter(Users);
